import { Link as RouterLink } from 'react-router-dom';
import { getEditLink } from '@/features/experiences/lib/experience';
import type { PageExperience } from '@/features/experiences/types';
import { getPrintableMagicLink } from '@/features/magic/utils/getPrintableMagicLink';
import { ExperienceTypes, Role } from '@/types/gql.generated';
import { Flex, Link, Text } from '@/ui';

type Props = {
  experience: PageExperience;
};

const getNoun = (type: ExperienceTypes | undefined): string => {
  if (type === ExperienceTypes.Planner) {
    return 'planner';
  }

  return type === ExperienceTypes.Page ? 'page' : 'printable';
};

export const PublicViewNotice = ({ experience }: Props) => {
  // A printable has no editor of its own: it is edited in /magic, the way the
  // library opens it.
  const { to, state } =
    experience.type === ExperienceTypes.Printable
      ? getPrintableMagicLink(experience.id)
      : { to: getEditLink(experience), state: undefined };

  return (
    <Flex
      align="center"
      bg="brand.40"
      borderBottom="1px solid"
      borderColor="line.soft"
      color="brand.700"
      justify="center"
      px="4"
      py="1.5"
    >
      <Text fontSize="ah-control" lineHeight={1.4} textAlign="center">
        You&apos;re {experience.role === Role.Owner ? 'the owner' : 'an editor'}{' '}
        of this {getNoun(experience.type)}!{' '}
        <Link
          as={RouterLink}
          color="inherit"
          fontWeight={600}
          state={state}
          textDecor="underline"
          to={to}
        >
          Edit
        </Link>
      </Text>
    </Flex>
  );
};
